module.exports = __webpack_public_path__ + "img/volodymyr-hryshchenko-x_OKGbxB3fA-unsplash.73a28493.webp";